import { Typography } from '@mui/material'
import { memo } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'

interface Props {
  title: string
  description: string
  /** Swaps the clipboard art for the search art when a filter, not the data, is the reason. */
  isFiltered?: boolean
  /** Fixed height, so the chart card keeps its size when the plot drops out. */
  height?: number
}

/**
 * Shared shape for every empty state on this screen — same composition the golden
 * `EmptyContractors` uses: art + `h4`/600 title + `body2` `SHADES_GREY_400` description.
 */
const ExpirationsEmptyStateComponent = ({ title, description, isFiltered, height }: Props) => (
  <div
    css={[tw`flex flex-1 h-full justify-center items-center flex-col`, height ? { height } : null]}
  >
    <img src={isFiltered ? EmptySearchImage : EmptyImage} alt="" />
    <Typography css={tw`mb-1 mt-2`} variant="h4" fontWeight={600}>
      {title}
    </Typography>
    <Typography color={colors.SHADES_GREY_400} variant="body2">
      {description}
    </Typography>
  </div>
)

export const ExpirationsEmptyState = memo(ExpirationsEmptyStateComponent)
